export const SET_LOGGED_IN_USER = 'SET_LOGGED_IN_USER';
export const REMOVE_LOGGED_IN_USER = 'REMOVE_LOGGED_IN_USER';
export const SET_COMMON_DATA = "SET_COMMON_DATA"
export const SET_LOGGED_USER_DATA = "SET_LOGGED_USER_DATA";
